import React from 'react';
import './SuspensionModal.css';

const SuspensionModal = ({ isOpen, status, message, endDate, onClose }) => {
  if (!isOpen) return null;

  const isExpired = status === 'expired';
  const isSuspended = status === 'suspended';

  return (
    <div className="suspension-modal-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="suspension-modal" onClick={(e) => e.stopPropagation()}>
        <div className="suspension-modal-header">
          <div className={`suspension-icon ${status}`}>
            {isSuspended ? '⚠️' : '⏰'}
          </div>
          <h2>
            {isSuspended ? 'Account Suspended' : 'Subscription Expired'}
          </h2>
        </div>
        
        <div className="suspension-modal-body">
          <p className="suspension-message">
            {message || (
              isSuspended
                ? 'Your account has been suspended. Please contact support for further assistance.'
                : 'Your subscription has expired. Please renew to continue using the platform.'
            )
          }
          </p>
          
          {isExpired && endDate && (
            <p className="expiry-date">
              Expired on: {new Date(endDate).toLocaleDateString()}
            </p>
          )}

          <div className="suspension-actions">
            <p className="contact-info">
              For further assistance, please contact our support team.
            </p>
            <button 
              className="btn-close-modal" 
              disabled
              style={{ opacity: 0.6, cursor: 'not-allowed' }}
            >
              I Understand
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuspensionModal;

